import React from "react";
import { Button } from "@progress/kendo-react-buttons";
import RequiredMessage from "@/app/components/webloading/errorHandling/RequiredMessage";
import GxSecondaryButtonRed from "@/app/components/common/actions/buttons/GxSecondaryButtonRed";
import GxSecondaryButtonBlue from "@/app/components/common/actions/buttons/GxSecondaryButtonBlue";
import GxSecondaryButtonyellow from "@/app/components/common/actions/buttons/GxSecondaryButtonyellow";
import GxHorizontalLine from "@/app/components/common/actions/buttons/GxHorizontalLine";
import GxPrimaryButton from "@/app/components/common/actions/buttons/GxPrimaryButton";
import GxSecondaryButton from "@/app/components/common/actions/buttons/GxSecondaryButton";


interface DialogFooterProps {
  handleClose: () => void;
  handleFooterSubmit?: () => void;
  handleSuspend: () => void;
  handleDelete: () => void;
  handleActivateUser:() => void;
  cancel: string;
  submit: string;
  type?: "button" | "submit";
  submitDisabled?: boolean;
  buttonloading?: boolean;
  requiredMessage?: string | null;
  buttonbaseRole: string;
  baseStatus: string;
}

const DialogFooterCusBtn: React.FC<DialogFooterProps> = ({
  handleClose,
  handleFooterSubmit,
  handleDelete,
  handleSuspend,
  handleActivateUser,
  cancel,
  submit,
  type,
  submitDisabled,
  buttonloading,
  requiredMessage,
  buttonbaseRole,
  baseStatus,
}) => {
  const handleSubmit = () => {
    if (handleFooterSubmit) {
      handleFooterSubmit();
    }
  };

  return (
    <div
      className={
        requiredMessage && requiredMessage !== ""
          ? "gx-dialog-actions gx-dialog-required"
          : "gx-dialog-actions"
      }
    >
      {requiredMessage && requiredMessage !== "" && (
        <div className="gx-required-message-child">
          <RequiredMessage message={requiredMessage} />
        </div>
      )}

      <GxHorizontalLine />
      <div className="flex space-x-2">
        
        {(buttonbaseRole !== "Owner" && buttonbaseRole !== "Owner-1" && buttonbaseRole !== "") ? (
          <>
            <GxSecondaryButtonRed handleClose={handleDelete} label={"Delete"} />
            {baseStatus === "I" ? (
              <GxSecondaryButtonBlue
                handleClose={handleActivateUser}
                label={"ACTIVATE USER"}
              />
            ) : (
              <GxSecondaryButtonyellow
                handleClose={handleSuspend}
                label={"SUSPEND"}
              />
            )}
          </>
        ) : (
          cancel !== "" && (
            <GxSecondaryButton handleClose={handleClose} label={cancel} />
          )
        )}

        {buttonloading ? (
          <Button
            disabled
            className="gx-dialog-action-button gx-submit-for-approval gx-h4-b"
          >
            <span className="gx-font-bold">Loading...</span>
          </Button>
        ) : (
          <GxPrimaryButton
            handleSubmit={handleSubmit}
            label={submit}
            type={type}
            disabled={submitDisabled}
          />
        )}
      </div>
    </div>
  );
};

export default DialogFooterCusBtn;
